import { LoginStage } from '@ax/constants';
import { RootState } from '../../';

export const selectAuthState = (state: RootState) => state.auth;
export const selectLoginStage = (state: RootState): LoginStage => selectAuthState(state).loginStage;
export const selectResetSession = (state: RootState): boolean =>
  selectAuthState(state).resetSession;
export const selectIsLogoutLoading = (state: RootState): boolean => selectAuthState(state).loading;
